angular.module('qkr').directive('greaterThan', greaterThanFunc);

function greaterThanFunc() {
    return {
        require: 'ngModel',
        link(scope, element, attrs, ngModel) {
            let startDate = null;
            scope.$watch(attrs.greaterThan, (newValue, oldValue) => {
                startDate = newValue;
                ngModel.$validate();
            });
            ngModel.$validators.greaterThan = function(value, value1) {
                return value > startDate;
            };
        }
    };
}



// WEBPACK FOOTER //
// ./src/coupons/directives/greaterThan.js